import { render, staticRenderFns } from "./new-index.vue?vue&type=template&id=cb56d4fc&scoped=true"
import script from "./new-index.vue?vue&type=script&lang=js"
export * from "./new-index.vue?vue&type=script&lang=js"
import style0 from "./new-index.vue?vue&type=style&index=0&id=cb56d4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb56d4fc",
  null
  
)

export default component.exports